module.exports = "/assets/22dfc4f6ca410353c101fd7554a09225.png";